const Orders = () => {
  return <h1>Orders</h1>;
};

export default Orders;
